import i18n from '@/i18n'

i18n.mergeLocaleMessage('en', {
    'onboarding': {
       'choose_opt_method': 'Select your method',
    },
})